
  import { Component, Prop, Vue } from "vue-property-decorator";

  import GET_MANAGER from "@/apollo/managers/GetManager.gql";
  import GET_CUSTOM_REQUESTS from "@/apollo/requests/GetCustomRequests.gql";
  import UPDATE_MANAGER from "@/apollo/managers/UpdateManager.gql";
  import DELETE_MANAGER_PROFILE from "@/apollo/managers/DeleteManagersProfile.gql";
  import GET_MANAGERS_COUNT from "@/apollo/managers/GetManagersCount.gql";

  import ManagerHeader from "@/components/managers/ManagerHeaderNew.vue";
  import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
  import TabsWithRoutes from "@/components/common/TabsWithRoutesNew.vue";
  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import NavGrayArrow from "@/components/icons//NavGrayArrow.vue";
  import getActiveManagersCountCondition from "@/helpers/queryConditions/getActiveManagersCountCondition";
  import TabNotificationBubble from "@/components/common/TabNotificationBubbleNew.vue";

  import RouteNames from "@/entities/RouteNames";
  import Message, { MessageDuration } from "@/data/notificationsMessages";
  import { NOTIFICATION } from "@/entities/Events";
  import { Company, Manager, Mutation_RootUpdate_Manager_By_PkArgs, User_Profile, User,
  Manager_Contractor_Aggregate,
  Project_Bool_Exp,
  Project_Aggregate,
  Manager_Contractor_Bool_Exp,
  Posting_Bool_Exp,
  Posting_Aggregate,
  Document_Aggregate,
  Document_Bool_Exp,
  } from "@/generated/graphql";
  import { FetchResult } from "apollo-link";
  import RouteTabs from "@/entities/RouteTabs";
  import getAuthData from "@/utils/getAuthData";
  import auth from "@/services/auth";
  interface ManagerDetails {
    activeManagersCount: number;
    accessAllowedManagersCount: number;
    manager: Manager | null;
    requestCount: Manager_Contractor_Aggregate | null;
    projectCount: Project_Aggregate | null;
    contractorCount: Manager_Contractor_Aggregate | null;
    postingCount: Posting_Aggregate | null;
    documentCount: Document_Aggregate | null;
  }

  @Component({
    components: {
      ManagerHeader,
      TabsWithRoutes,
      EmptyListPlaceholder,
      NavGrayArrow,
      LoadingOverlay,
      TabNotificationBubble,
    },
    apollo: {
      managerDetails: {
        query: GET_MANAGER,
        variables() {
          return {
            id: this.$route.params.id,
            activeManagersCountCondition: getActiveManagersCountCondition(this.company.id),
            isManagersCountUnlimited: this.isManagersCountUnlimited,
            projectCountWhere: this.projectCountWhere,
            contractorCountWhere: this.contractorCountWhere,
            postingCountWhere: this.postingCountWhere,
            documentCountWhere: this.documentCountWhere,
          };
        },
        update(data) {
          this.familyName = data.manager_by_pk.user.family_name;
          this.givenName = data.manager_by_pk.user.given_name;
          this.managerDetails.manager = data.manager_by_pk; 
          const {
            activeManagersCount = undefined,
            subscriptions = undefined,
            manager_by_pk: manager,
            requestCount,
            projectCount,
            contractorCount,
            postingCount,
            documentCount,
          } = data;

          const basicDataFields = {
            manager,
            requestCount,
            projectCount,
            contractorCount,
            postingCount,
            documentCount,
          }

          if (this.isManagersCountUnlimited) {
            return basicDataFields;
          }
          return {
            
            ...basicDataFields,
            activeManagersCount: activeManagersCount.aggregate.count,
            accessAllowedManagersCount: subscriptions[0].subscription_plan.subscription_plan_access_permission.managers_count,
          }
        },
      },
    },
  })
  export default class ManagerPage extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Object, required: true }) readonly company!: Company;

    managerStatusProcessing = false;
    currentUserId: string = "";
    managerDeletionProcessing=false;
    familyName: string = "";
    givenName: string = "";
    routes: typeof RouteNames = RouteNames;
    managerDetails: ManagerDetails = {
      activeManagersCount: 0,
      accessAllowedManagersCount: 0,
      manager: null,
      requestCount: null,
      projectCount: null,
      contractorCount: null,
      postingCount: null,
      documentCount: null,
    }
    updatedRequestsNumber: null | number = null;
    updatedProjectsNumber: null | number = null;
    updatedPostingNumber: null | number = null;
    updatedDocumentsNumber: null | number = null;

    routeTabs: RouteTabs = {
      [RouteNames.MANAGER_ABOUT]: "about",
      [RouteNames.MANAGER_PROJECTS]: "clients",
      [RouteNames.MANAGER_CONTRACTORS]: " Resources",
      [RouteNames.MANAGER_REQUESTS]: "requests",
      [RouteNames.MANAGER_JOB_POSTINGS]: "job postings",
      [RouteNames.MANAGER_DOCUMENTS]: "documents",
    };
    routeTabsManager: RouteTabs = {
      [RouteNames.MANAGER_ABOUT]: "about",
      [RouteNames.MANAGER_CONTRACTORS]: "Resources",
      [RouteNames.MANAGER_JOB_POSTINGS]: "job postings",
    };
    get manager(): Manager | null {
      return this.managerDetails.manager;
    }
    get getRoleAdmin(): boolean {
      if(this.currentUser.role == "MANAGER")
      {
        return false;
      }
      else{
        return true;
      }
    }
    get requests(): string {
      if (this.updatedRequestsNumber) {
        return this.updatedRequestsNumber.toString();
      }
      if (this.updatedRequestsNumber === 0) {
        return "";
      }
      const count = this.managerDetails.requestCount?.aggregate?.count;
      return count ? count.toString() : "";
    }

get managersRoute() {
  return {
    name: RouteNames.MANAGE_MANAGERS,
  }
}
    get projectsNumber(): string {
      if (this.updatedProjectsNumber){
        return this.updatedProjectsNumber.toString();
      }
      if (this.updatedProjectsNumber === 0) {
        return "";
      }
      const count = this.managerDetails?.projectCount?.aggregate?.count;
      return count ? count.toString() : "";
    }

    get contractorsNumber(): string {
      const count = this.managerDetails?.contractorCount?.aggregate?.count;
      return count ? count.toString() : "";
    }

    get postingsNumber(): string {
      if (this.updatedPostingNumber) {
        return this.updatedPostingNumber.toString();
      }
      if (this.updatedPostingNumber === 0) {
        return "";
      }
      const count = this.managerDetails?.postingCount?.aggregate?.count;
      return count ? count.toString() : "";
    }

    get documentsNumber(): string {
      if (this.updatedDocumentsNumber) {
        return this.updatedDocumentsNumber.toString();
      }
      if(this.updatedDocumentsNumber === 0) {
        return "";
      }
      const count = this.managerDetails?.documentCount?.aggregate?.count;
      return count ? count.toString() : "";
    }

    get showRequestsBubble(): boolean {
      return Number(this.requests) > 0;
    }

    get phone(): string {
      const phone = this.manager?.user.private_data?.phone;
      return phone
        ? `+${phone}`
        : '';
    }

    get projectCountWhere(): Project_Bool_Exp {
      if (!this.manager) {
        return {};
      }
      return { manager_id: { _eq: this.manager.id}}
    }

    get contractorCountWhere(): Manager_Contractor_Bool_Exp {
      if (!this.manager) {
        return {};
      }

      var confirmedConditions = {};

      if(!(this.currentUser.role === "ADMIN")) {
        confirmedConditions = {
          confirmed: {
        _eq: true
      }
        }
      }

      return {
        _and: [
          { manager_id: { _eq: this.manager.id } },
          { approved: { _eq: true } },
          { contractor: {
            deleted: { _eq: false },
            approved: { _eq: true },
            user: confirmedConditions,
          }}
        ]
      }
    }

    get postingCountWhere(): Posting_Bool_Exp {
      if (!this.manager) {
        return {};
      }
      return { manager_id: { _eq: this.manager.id } }
    }

    get documentCountWhere(): Document_Bool_Exp {
      if (!this.manager) {
        return {};
      }
      return {
        _and: [
          {
            uploaded_by: {
              _eq: this.currentUser.id,
            },
          },
          {
            attached_to: {
              user_id: {
                _eq: this.manager.user.id,
              },
            },
          },
        ],
      }
    }


    get activeManagersCount(): number {
      return this.managerDetails.activeManagersCount;
    }

    get accessAllowedManagersCount(): number {
      return this.managerDetails.accessAllowedManagersCount
    }

    get isManagersCountUnlimited(): boolean {
      return !this.currentUser.subscription_required;
    }

    get managerActivationAllowed(): boolean {
      if (this.isManagersCountUnlimited) {
        return true;
      }
      return this.accessAllowedManagersCount > this.activeManagersCount;
    }

    get isManagerExist(): boolean {
      return this.manager !== null;
    }

    get isActive(): boolean {
      return this.manager?.status !== "SUSPENDED";
    }

    get profile(): User_Profile | undefined {
      if (!this.manager) {
        return;
      }
      return this.manager.user.profile!;
    }

    get managerFullName(): string {
      if (!this.manager) {
        return "";
      }

      const firstName = this.manager.user.given_name;
      const lastName = this.manager.user.family_name;
      return `${firstName} ${lastName}`;
    }

    toggleSuspend(): void {
      this.$confirm({
        title: `${this.isActive ? "Suspend" : "Activate"} Manager`,
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm: any) => {
          if (confirm) {
            try {
              this.managerStatusProcessing = true;

              if (!this.isActive) {
                const allowedActivateManager = await this.isManagerActivationAllowed(this.company.id);

                if (!allowedActivateManager) {
                  this.$eventBus.emit(
                    NOTIFICATION,
                    Message.errorMessage(
                      "To activate this manager you need to upgrade your subscription",
                      MessageDuration.LONG
                    )
                  );
                  return;
                }
              }

              await this._updateManager({
                _set: {
                  status: this.isActive ? "SUSPENDED" : "ACTIVE",
                },
                pk_columns: { id: this.manager?.id },
              });

              this.$eventBus.emit(NOTIFICATION, Message.successMessage("Manager status was updated"));

              if (!this.isActive) {
                await this.$apollo.queries.managerDetails.refetch();
              }
            } catch (e) {
              this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
            } finally {
              this.managerStatusProcessing = false;
            }
          }
        },
      });
    }
    toggleDelete(): void {
      this.$confirm({
        title: `Delete Manager`,
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm: any) => {
          if (confirm) {
            try {
              this.managerDeletionProcessing = true;
              //check here to start deletion logic
              await this._deleteManager(              
              );
              await this._deleteCongitoUserPool();

              this.$eventBus.emit(NOTIFICATION, Message.successMessage("Manager Deleted"));

              if (!this.isActive) {
                await this.$apollo.queries.managerDetails.refetch();
              }
            } catch (e) {
              this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
            } finally {
              this.managerDeletionProcessing = false;
            }
          }
        },
      });
    }
    async isManagerActivationAllowed(companyId: string): Promise<boolean> {
      if (this.isManagersCountUnlimited) {
        return true;
      }

      const { data } = await this.$apollo.query({
        query: GET_MANAGERS_COUNT,
        variables: {
          companyId,
          activeManagersCountCondition: getActiveManagersCountCondition(companyId),
        },
        fetchPolicy: "no-cache",
      });

      const allowedManagersCount =
        data.company_by_pk.subscriptions[0].subscription_plan.subscription_plan_access_permission.managers_count;
      const activeManagersCount = data.activeManagersCount.aggregate.count;

      return allowedManagersCount > activeManagersCount;
    }

    async _updateManager(input: Mutation_RootUpdate_Manager_By_PkArgs): Promise<FetchResult> {
      return await this.$apollo.mutate({
        mutation: UPDATE_MANAGER,
        variables: input,
      });
    }
    async _deleteManager() {
      this.currentUserId = await auth.getSessionUserId();
     return this.$apollo.mutate({
        mutation: DELETE_MANAGER_PROFILE,
        variables: {
          id: this.manager?.user.id,
          managerId: this.manager?.id,
          currentUserId: this.currentUserId
        }
      });
    }
    async _deleteCongitoUserPool(){
      try {
          const uri = `${process.env.VUE_APP_LAMBDA}/delete-cognito-user`;
          const { headers } = await getAuthData();
          const { data }: any = await this.axios.post(uri, { data: {
            username: this.manager?.user.id,
          }}, { headers });
          return data.valid;
        } catch (error) {
          return false
        } finally {
        }
    }
  }
